import { SearchOutlined } from "@ant-design/icons";
import {
  Skeleton,
  Typography
} from "antd";
import {
  FC,
  Fragment,
  useEffect,
  useState
} from "react";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

//!STYLES
import { isToday } from "common/enums";
import AppButton from "components/libs/button";
import * as appRoutes from "config/routes.config";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useGetHistoriqueStudentQuery } from "store/services/teacher/classes.services";
import s from "../assets/calendar.module.css";
import CardReservationsStudent from "./card";

import AppResult from "components/appResults";

interface ReservationsCalendarProps {
  setCalendarData: React.Dispatch<any>;
  filter?: string;
}

const { Text } = Typography;

const CalendarOfReservationStudent: FC<ReservationsCalendarProps> = ({ setCalendarData, filter }) => {

  const { user } = useSelector((state) => state.auth);
  const { isReservationsUpdated } = useSelector((state) => state.app);
  const [courses, setCourses] = useState<any>([]);

  const hasCourses = courses && Object.keys(courses).length > 0;

  const {
    data: reservations,
    isLoading,
    isError,
    refetch,
  } = useGetHistoriqueStudentQuery(user?._id);

  const navigate = useNavigate();
  const handleClick = () => {
    navigate(appRoutes.STUDENT_SEARCH_BEST_TEACHER);
  }

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1050);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 1050);
  };
  window.addEventListener('resize', handleResize);

  useEffect(() => {
    refetch();
  }, []);

  useEffect(() => {
    refetch();
  }, [isReservationsUpdated]);

  useEffect(() => {
    if (reservations) {
      setCalendarData(reservations?.data);
    }
  }, [reservations]);

  useEffect(() => {
    if (reservations?.data) {
      const groupedByDate = reservations?.data.reduce((acc: any, course: any) => {
        const date = new Date(course.startDate).toISOString().split("T")[0];
        if (!acc[date]) {
          acc[date] = [];
        }
        acc[date].push(course);
        return acc;
      }, {});

      setCourses(groupedByDate);
    }
  }, [reservations]);

  useEffect(() => {
    if (filter) {
      let filtered = courses;

      if (filter === 'all') {
        const groupedByDate = reservations?.data.reduce((acc: any, course: any) => {
          const date = new Date(course.startDate).toISOString().split("T")[0];
          if (!acc[date]) {
            acc[date] = [];
          }
          acc[date].push(course);
          return acc;
        }, {});

        setCourses(groupedByDate);
      }
      else if (filter === 'particular') {
        filtered = reservations?.data.filter(
          (session: any) =>
            session.classeId &&
            session.classeId === "" || session.classeId === undefined || session.classeId === null
        );

        const groupedByDate = filtered?.reduce((acc: any, course: any) => {
          const date = new Date(course.startDate).toISOString().split("T")[0];
          if (!acc[date]) {
            acc[date] = [];
          }
          acc[date].push(course);
          return acc;
        }, {});

        setCourses(groupedByDate);
      }
      else {
        filtered = reservations?.data.filter(
          (session: any) =>
            session.classeId &&
            session.classeId === filter
        );

        const groupedByDate = filtered?.reduce((acc: any, course: any) => {
          const date = new Date(course.startDate).toISOString().split("T")[0];
          if (!acc[date]) {
            acc[date] = [];
          }
          acc[date].push(course);
          return acc;
        }, {});

        setCourses(groupedByDate);
      }
    }
  }, [filter]);

  return (
    <div>
      {isLoading ? (
        <>
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
        </>
      ) : (
        <Fragment>
          <div className={s.calendar}>
            {hasCourses ? (
              courses && Object.keys(courses)?.map((date) => {
                return (
                  <>
                    <div key={date} style={{ marginTop: "10px" }}>
                      <div className={s.dateBox}>
                        {new Intl.DateTimeFormat("fr-FR", {
                          weekday: "long",
                          day: "numeric",
                          month: "long",
                          year: "numeric",
                        }).format(new Date(date))}
                        {isToday(date) && <div className={s.todayBox}>Aujourd’hui</div>}
                        <div className={s.horizontalLine}></div>
                      </div>
                      {!isMobile && courses[date].map((course: any) => (
                        <div key={course.id}>
                          <CardReservationsStudent course={course} isHistorique={false} />
                        </div>
                      ))}

                      {isMobile && <div className={s.cardDisplay} /* className={`${s.cardDisplay} ${courses[date].length === 1 ? s.singleCourse : ""}`} */>
                        {courses[date].map((course: any) => (
                          <div key={course.id}>
                            <CardReservationsStudent course={course} isHistorique={false} />
                          </div>
                        ))}
                      </div>}
                    </div>
                  </>
                );
              })
            ) : (
              <div className={s.emptyClass}>
                <AppResult status={"info"} title={"Aucune séance"}></AppResult>
                <div style={{ marginBottom: "30px", display: "flex", alignItems: "center", justifyContent: "center", }}>
                  <AppButton icon={<SearchOutlined />} onClick={handleClick}>
                    Trouver un prof
                  </AppButton>
                </div>
              </div>
            )}
          </div>
        </Fragment>
      )}
    </div>
  );
};

export default CalendarOfReservationStudent;
